import type { UserType } from '../../side-menu/types';

const SHELL_ROUTE_RE = /^\/(solo|shops|client|admin)(\/|$)/;

export const isShellRoute = (pathname: string): boolean =>
  SHELL_ROUTE_RE.test(pathname);

export const extractShopSlugFromPath = (pathname: string): string | undefined => {
  const match = pathname.match(/^\/shops\/([^/]+)/);
  return match ? match[1] : undefined;
};

export const mapRoleToUserType = (role: string | null): UserType => {
  switch (role) {
    case 'client':
      return 'USER';
    case 'independent_provider':
      return 'INDEPENDENT_PROVIDER';
    case 'shop_owner':
      return 'SHOP_OWNER';
    case 'shop_manager':
      return 'SHOP_OWNER';
    case 'staff_provider':
      return 'STAFF_PROVIDER';
    default:
      return 'USER';
  }
};

export const resolveEffectiveShopSlug = (
  userType: UserType,
  urlShopSlug?: string,
  bootstrapShopSlug?: string,
  propShopSlug?: string,
): string | undefined => {
  // Priority: prop > URL > bootstrap (for shop roles only)
  if (propShopSlug) return propShopSlug;
  if (urlShopSlug) return urlShopSlug;

  const isShopRole = userType === 'SHOP_OWNER' || userType === 'STAFF_PROVIDER';
  if (isShopRole && bootstrapShopSlug) return bootstrapShopSlug;

  return undefined;
};
